// extracted by mini-css-extract-plugin
export default {"wrapper":"Vp-z","response":"Wp-z","error":"Xp-z","disabled":"Yp-z","buttons":"Zp-z","feedbackQuestionSection":"_p-z","yesNoWrapper":"aq-z"};